import { ActionButton, Spinner, SpinnerSize } from "@fluentui/react";
import { useEffect, useRef } from "react";
import { Utils } from "../../../common/views/Utils";
import { PhoneModel } from "../../models/PhoneModel";
import { useCustomerPhoneVM } from "../../viewmodels/CustomerPhoneVM";
import PhoneEntryView from "./PhoneEntryView";
import PhoneGridView from "./PhoneGridView";

export type CustomerPhoneProps = {
    onSelect?: (phone: PhoneModel) => void;
}

export default function CustomerPhoneView({ onSelect }: CustomerPhoneProps) {
    const hasLoaded = useRef(false);
    const vm = useCustomerPhoneVM();

    useEffect(() => {
        if (hasLoaded.current) return;

        hasLoaded.current = true;

        vm.getList();
    }, [vm]);

    const onDelete = (phone: PhoneModel) => {
        const phoneNo = Utils.formatKhPhone(phone.countryCode, phone.phoneNo);

        if (window.confirm(`Are you sure to delete phone # ${phoneNo}?`)) {
            vm.del(phone.id);
        }
    }

    const onClose = () => {
        vm.setIsEdit(false);
        vm.setShowEntry(false);
        vm.resetForm();
    }

    const onSubmit = () => {
        if (vm.isEdit) {
            vm.edit();
        } else {
            vm.create();
        }
    }

    const addButton = () => {
        return <>
            <ActionButton
                iconProps={{ iconName: "Add" }}
                onClick={() => vm.setShowEntry(true)}
            >Add New</ActionButton>
        </>;
    }

    const headerView = () => {
        return <div className="ph-15 pv-10 container">
            <div className="font-title pr-10" style={{ marginBottom: 4 }}>Phones</div>
            {addButton()}
        </div>;
    }

    const mainContent = () => {
        return <div className="ms-Grid">
            <div className="ms-Grid-row center">
                {headerView()}
            </div>

            <div>
                {vm.loading && <Spinner size={SpinnerSize.large} />}

                <PhoneGridView
                    phones={vm.phones}
                    key={vm.listHash}
                    onEdit={(phone: PhoneModel) => {
                        vm.setForm(phone);
                        vm.setIsEdit(true);
                        vm.setShowEntry(true);
                    }}
                    onDelete={onDelete}
                    onSelect={onSelect}
                />
            </div>
        </div>;
    }

    return <>
        {mainContent()}

        {vm.showEntry && <>
            <PhoneEntryView
                isEdit={vm.isEdit}
                form={vm.form}
                errorMessages={vm.errorMessages}
                submitting={vm.submitting}
                onValueChange={vm.setField}
                onSubmit={onSubmit}
                onClose={onClose}
            />
        </>}
    </>;
}